export default "__VITE_ASSET__BZIgGoc$__"